(function (angular) {
	'use strict';

	angular
		.module('settingsModule')
		.controller('EditEntityAccount', [
			'$filter',
			'$scope',
			'FileUploadFactory',
			'globalConfig',
			'mixpanelFactory',
			'US_STATES',
			EditEntityAccountFunction
		]);

	function EditEntityAccountFunction(
		$filter,
		$scope,
		FileUploadFactory,
		globalConfig,
		mixpanelFactory,
		US_STATES
	) {
		var editEntityAccount = this;

		editEntityAccount.updateTaxClassificationOptions = function() {
			if(editEntityAccount.entityType.value === 'LLC') {
				editEntityAccount.taxClassificationOptions = editEntityAccount.llcTaxClassifications;
				editEntityAccount.taxClassification = editEntityAccount.taxClassificationOptions[0];
			} else if (editEntityAccount.entityType.value === 'SM_LLC') {
				editEntityAccount.taxClassificationOptions = editEntityAccount.singleMemberLlcTaxClassifications;
				editEntityAccount.taxClassification = editEntityAccount.taxClassificationOptions[0];
			} else if (editEntityAccount.entityType.value === 'C_CORP') {
				editEntityAccount.taxClassificationOptions = editEntityAccount.cCorpTaxClassifications;
				editEntityAccount.taxClassification = editEntityAccount.taxClassificationOptions[0];
			} else if (editEntityAccount.entityType.value === 'S_CORP') {
				editEntityAccount.taxClassificationOptions = editEntityAccount.sCorpTaxClassifications;
				editEntityAccount.taxClassification = editEntityAccount.taxClassificationOptions[0];
			} else {
				editEntityAccount.taxClassificationOptions = [{
					value: 'PARTNERSHIP',
					label: 'Limited Partnership'
				}];
				editEntityAccount.taxClassification = editEntityAccount.taxClassificationOptions[0];
			}
		};

		editEntityAccount.$onInit = function() {
			editEntityAccount.states = US_STATES;

			angular.extend(editEntityAccount, globalConfig);

			editEntityAccount.name = editEntityAccount.serializedForm.name;

			mixpanelFactory.track('Profile Form viewed', { 'Entity Type' : 'LLC' });

			editEntityAccount.showTin = angular.isUndefined(editEntityAccount.serializedForm.ein);

			editEntityAccount.entityType = $filter('filter')(editEntityAccount.entityTypes, {'value': editEntityAccount.serializedForm.entityType}, true)[0];
			editEntityAccount.updateTaxClassificationOptions();
			editEntityAccount.taxClassification = $filter('filter')(editEntityAccount.llcTaxClassifications, {'value': editEntityAccount.serializedForm.taxClassification}, true)[0];

			editEntityAccount.registrationState = $filter('filter')(editEntityAccount.states, {'abbreviation': editEntityAccount.serializedForm.registrationState}, true)[0];
			editEntityAccount.state = $filter('filter')(editEntityAccount.states, {'abbreviation': editEntityAccount.serializedForm.state}, true)[0];

			editEntityAccount.certificateOfFormation = FileUploadFactory.createStateObj('IDENTIFICATION_DOCUMENT');
			editEntityAccount.operatingAgreement = FileUploadFactory.createStateObj('IDENTIFICATION_DOCUMENT');
			editEntityAccount.resetUpload = FileUploadFactory.resetUpload;
			editEntityAccount.uploadFiles = FileUploadFactory.uploadFiles;

			$scope.$watch('editEntityAccount.investmentCompanyProfileForm.taxClassification', function(taxClassification) {
				if(angular.isDefined(taxClassification)) {
					taxClassification.$setTouched();
				}
			});
		};
	}
})(window.angular);
